// extracted by mini-css-extract-plugin
export default {"layout":"student-layout_layout__6-PF5","content":"student-layout_content__Qsy5E"};